/**
 * Server speichert viele Zeitstempel als naive UTC-DATETIME („YYYY-MM-DD HH:MM:SS“).
 * Ohne Zeitzone parst `new Date(...)` das in Browsern als lokal → in DE (CEST) −2h.
 */
export function parseMailDate(value) {
  if (value == null || value === '') return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === 'number' && Number.isFinite(value)) {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const raw = String(value).trim();
  if (!raw) return null;

  if (/[zZ]$|[+-]\d{2}:?\d{2}$/.test(raw)) {
    const d = new Date(raw);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  const normalized = raw.includes('T') ? raw : raw.replace(' ', 'T');
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(normalized)) {
    const asUtc = new Date(`${normalized}Z`);
    if (!Number.isNaN(asUtc.getTime())) return asUtc;
  }

  const d = new Date(raw);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatMailDateTime(value, locale = 'de-DE') {
  const date = parseMailDate(value);
  if (!date) return value == null ? '' : String(value);
  return date.toLocaleString(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Kalender-Wochentag in Europe/Berlin (Kampagnen-Versand). */
const MAIL_TZ = 'Europe/Berlin';

export function isWeekendMailDay(date = new Date()) {
  const d = date instanceof Date ? date : parseMailDate(date) || new Date(date);
  if (Number.isNaN(d.getTime())) return false;
  const w = new Intl.DateTimeFormat('en-US', {
    timeZone: MAIL_TZ,
    weekday: 'short',
  }).format(d);
  return w === 'Sat' || w === 'Sun';
}

/**
 * Samstag/Sonntag (Berlin) → nächster Montag, Uhrzeit bleibt erhalten.
 * Werktage unverändert.
 */
export function skipWeekendToNextMonday(date) {
  let d = date instanceof Date ? new Date(date.getTime()) : parseMailDate(date) || new Date(date);
  if (Number.isNaN(d.getTime())) return null;
  let guard = 0;
  while (isWeekendMailDay(d) && guard < 3) {
    d = new Date(d.getTime() + 24 * 60 * 60 * 1000);
    guard += 1;
  }
  return d;
}
